import { styleAccessPoint } from './apFeatures';
import { getLinkStyler } from './linkFeatures';
import { styleSite } from './siteFeatures';
import { store } from '../../store';
import { DEFAULT_GRAPHICS_PREFS } from '../../app.constants';

const getFeatureStyle = (feature, isSelected) => {
  const kind = feature?.properties?.kind;

  const graphics = {
    ...DEFAULT_GRAPHICS_PREFS,
    ...(store.getState().mainFrame.prefs?.graphics ?? {}),
  };

  if (kind === 'network_site' && feature.properties.node_type === 'POP') {
    // POP sites use a different style to other network sites
    return styleSite(feature, '#ff0000', '#ffffff', isSelected);
  }

  return {
    network_site: styleSite(
      feature,
      '#000000',
      graphics.networkSiteColor,
      isSelected
    ),
    subscriber_site: styleSite(
      feature,
      '#000000',
      graphics.subscriberSiteColor,
      isSelected
    ),
    access_point: styleAccessPoint(
      feature,
      isSelected,
      graphics.accessPointColor
    ),
    ptp_link: getLinkStyler(
      graphics.ptpLinkColor,
      graphics.ptpLinkLineThickness,
      graphics.ptpLinkLineStyle
    )(feature, isSelected),
    mesh_link: getLinkStyler(
      graphics.meshLinkColor,
      graphics.meshLinkLineThickness,
      graphics.meshLinkLineStyle
    )(feature, isSelected),
    pmp_link: getLinkStyler(
      graphics.pmpLinkColor,
      graphics.pmpLinkLineThickness,
      graphics.pmpLinkLineStyle
    )(feature, isSelected),
  }[kind];
};

export default getFeatureStyle;
